import { getIdTokenResult, type User } from 'firebase/auth';
import { ReactNode, useEffect, useState } from 'react';
import { useSettings } from '@/hooks/useSettings';
import { UserProfile } from '@/types';
import { UserContext } from './UserContext';

interface UserProviderProps {
  children: ReactNode;
  user: User | null;
  currentUser: UserProfile | null;
}

export function UserProvider({ children, user, currentUser }: UserProviderProps) {
  const [adminCheck, setAdminCheck] = useState({ checkedUid: '', isAdmin: false });
  const { settings } = useSettings(user);
  const uid = user?.uid ?? '';

  useEffect(() => {
    if (!user || !uid) return;

    let active = true;
    getIdTokenResult(user, true)
      .then(token => {
        if (active) setAdminCheck({ checkedUid: uid, isAdmin: token.claims.admin === true });
      })
      .catch(() => {
        if (active) setAdminCheck({ checkedUid: uid, isAdmin: false });
      });
    return () => {
      active = false;
    };
  }, [uid, user]);

  const isAdmin = user !== null && adminCheck.checkedUid === uid && adminCheck.isAdmin;

  return (
    <UserContext.Provider value={{ user, currentUser, settings, isAdmin }}>
      {children}
    </UserContext.Provider>
  );
}
